import AuthService from "@/services/auth.service";
import store from "@/store";
import VueRouter, { createRouter, RouteRecordRaw, createWebHistory } from "vue-router";

const handleAsyncComponentError = (error: any): any => {
  console.error(error);
  window.alert("New version available! Please reload this page to continue.");
  window.location.reload();
};

async function handlePermissionDenied(
  to: VueRouter.RouteLocationNormalizedGeneric,
): Promise<VueRouter.RouteLocationRaw> {
  let pathLocation = "";
  if (window.location.pathname.startsWith("/sys-admin")) {
    await AuthService.sysAdminSignOut();
    await store.dispatch("signOut");
    pathLocation = "/sys-admin/signin";
  } else {
    pathLocation = "auth";
  }
  const tenantPreferredId = to.params["tenant_preferred_id"];

  return {
    path: pathLocation,
    query: {
      redirect: to.query.redirect || to.fullPath,
      tenant_preferred_id: tenantPreferredId,
    },
  };
}

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home page",
    component: () => import("@/views/TenantLayout.vue").catch(handleAsyncComponentError),
  },
  // {
  //   path: "/auth",
  //   name: "Auth page",
  //   component: () => import("@/components/common/Auth.vue").catch(handleAsyncComponentError),
  // },
  {
    path: "/error",
    name: "Error page",
    component: () => import("@/views/Error.vue").catch(handleAsyncComponentError),
    children: [
      {
        path: "auth",
        component: () => import("@/components/error/AuthFailure.vue").catch(handleAsyncComponentError),
      },
      {
        path: "404",
        component: () => import("@/components/error/URL404.vue").catch(handleAsyncComponentError),
      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    redirect: "error",
  },

  // {
  //   path: "/t/:contractId/g/:serviceGroupId",
  //   meta: { requiresAuthTenant: true },
  //   component: () => import("@/views/TenantLayout.vue").catch(handleAsyncComponentError),
  //   children: [
  //     {
  //       path: "create-site",
  //       component: () => import("@/views/CreateSite.vue").catch(handleAsyncComponentError),
  //     },
  //     {
  //       path: "history",
  //       component: () => import("@/views/History.vue").catch(handleAsyncComponentError),
  //     },
  //     {
  //       path: "sitemap",
  //       component: () => import("@/views/Sitemap.vue").catch(handleAsyncComponentError),
  //     },
  //     {
  //       path: "link",
  //       component: () => import("@/views/Link.vue").catch(handleAsyncComponentError),
  //     },
  //     {
  //       path: "contents",
  //       component: () => import("@/views/Contents.vue").catch(handleAsyncComponentError),
  //     },
  //     {
  //       path: "contents-detail",
  //       component: () => import("@/views/ContentsDetail.vue").catch(handleAsyncComponentError),
  //     },
  //   ],
  // },

  {
    path: "/sys-admin/signin",
    component: () => import("@/components/common/SignInForAdmin.vue").catch(handleAsyncComponentError),
  },
  {
    path: "/sys-admin",
    meta: { requiresAuthSysAdmin: true },
    component: () => import("@/views/SystemAdmin.vue").catch(handleAsyncComponentError),
    children: [
      {
        path: "home",
        component: () => import("@/components/system/HomeAdmin.vue"),
      },
      {
        path: "",
        redirect: "/sys-admin/signin",
      },
      {
        path: "contract-detail/:contractId/g/:serviceGroupId",
        children: [
          {
            path: "create-site",
            component: () => import("@/views/CreateSite.vue").catch(handleAsyncComponentError),
          },
          {
            path: "history",
            component: () => import("@/views/History.vue").catch(handleAsyncComponentError),
          },
          {
            path: "sitemap",
            component: () => import("@/views/Sitemap.vue").catch(handleAsyncComponentError),
          },
          {
            path: "link",
            component: () => import("@/views/Link.vue").catch(handleAsyncComponentError),
          },
          {
            path: "contents",
            component: () => import("@/views/Contents.vue").catch(handleAsyncComponentError),
          },
          {
            path: "contents-detail",
            component: () => import("@/views/ContentsDetail.vue").catch(handleAsyncComponentError),
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
});

router.beforeEach((to, from, next: VueRouter.NavigationGuardNext) => {
  new Promise<VueRouter.RouteLocationRaw | undefined>((resolve) => {
    if (to.path == "/") resolve({ path: "/auth" });
    if (to.matched.some((record) => record.meta.requiresAuthSysAdmin)) {
      if (store.getters.isInitialized && store.getters.user) {
        resolve(undefined);
      } else {
        store.commit("setState", { isInitialized: true });
        store.dispatch("signOut");
        // ログインの再試行
        AuthService.configure()
          .then(() => AuthService.currentUserInfo({ bypassCache: true }))
          .then(async (user) => {
            console.log("currentUserInfo sys", user);
            if (user) {
              store.dispatch("signIn", { user });
              resolve(undefined);
            } else {
              handlePermissionDenied(to).then(resolve);
            }
          })
          .catch((error) => {
            console.error(error);
            handlePermissionDenied(to).then(resolve);
          });
      }
    } else if (to.matched.some((record) => record.meta.requiresAuthTenant)) {
      if (store.getters.isInitialized) {
        resolve(undefined);
      } else {
        store.commit("setState", { isInitialized: true });
        handlePermissionDenied(to).then(resolve);
      }
    } else {
      store.commit("setState", { isInitialized: true });
      resolve(undefined);
    }
  }).then((location) => {
    if (location) {
      next(location); // Redirect to the resolved location
    } else {
      next(); // Proceed as normal
    }
  });
});

export default router;
